import { z } from 'zod';

export const EmailResponseSchema = z.array(
  z.object({
    id: z.number(),
    email: z.string(),
  }),
);

export const EmailRequestSchema = z.object({
  emails: z.array(z.string()),
});
